<template>
    <div>
        <!-- ------------- Message ------------- -->
        <p class="tw-text-sm tw-text-gray-400 tw-px-4 tw-text-center">{{ $t('app.text_forgot_code') }}</p>
        <!-- ------------- Email ------------- -->
        <div class="tw-relative">
            <v-otp-input
              v-model="otp_code"
              length="6"
              type="text"
              :disabled="loading_code"
              @finish="submitVerification"
            />
            <v-overlay absolute :value="loading_code">
              <v-progress-circular
                indeterminate
                color="primary"
              />
            </v-overlay>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        email: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        valid: true,
        loading_code: false,
        otp_code: '',
    }),
    methods: {
        // El servidor valida el código (antes se comparaba acá, contra uno
        // que había inventado el propio navegador).
        submitVerification(rsp) {
            this.loading_code = true
            this.$store.dispatch('password/verifyResetCode', {
                email: this.email,
                token: rsp,
            }).then((res) => {
                const valid = Boolean(res.data && res.data.valid)
                this.loading_code = false
                this.$emit('alert-snackbar',{
                    status:true,
                    color: valid ? 'success':'warning',
                    msg: valid ? this.$t('app.success_code') : this.$t('app.error_code'),
                })
                if (valid) {
                    this.$emit('code-verified', rsp)
                } else {
                    this.otp_code = ''
                }
                this.$emit('page-form',{
                    f1:false,
                    f2:false,
                    f3:!valid,
                    f4:valid,
                })
            })
        },
    },
}
</script>

<style>
</style>